export const accountNumberRegExp = /^\d{9,18}$/
export const ifscRegExp = /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/
export const panCardRegExp = /(^([a-zA-Z]{5})([0-9]{4})([a-zA-Z]{1})$)/
export const phoneRegExp = /^([0|\+[0-9]{1,5})?([6-9][0-9]{9})$/
export const alphabetsRegExp = /^[A-Za-z ]+$/
export const noEmojiesRegExp =
  /^[\u0020-\u007e\u00a0-\u00ff\u0152\u0153\u0178]+$/g
